module.exports = new __parcel__URL__("blob_sprite.d83cd357.png").toString();